/**
 * Container component that holds the various pages of the board.
 */
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'bhub-page-holder',
    templateUrl: './bhub-page-holder.component.html',
    styleUrls: ['./bhub-page-holder.component.scss'],
    standalone: false
})
export class BhubPageHolderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
